import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiUrlService {
  private _baseUrl: string = environment.baseUrl;

  get baseUrl(): string {
    return this._baseUrl;
  }

  setBaseUrl(url: string): void {
    const trimmed = (url ?? '').trim();
    if (!trimmed) return;
    try {
      const parsed = new URL(trimmed);
      const isHttps = parsed.protocol === 'https:';
      const isHttp = parsed.protocol === 'http:';
      if (!isHttps && !isHttp) {
        console.warn(`[ApiUrlService] Invalid protocol: ${parsed.protocol}`);
        return;
      }
      if (environment.production && isHttp &&
          parsed.hostname !== 'localhost' &&
          parsed.hostname !== '127.0.0.1' &&
          parsed.hostname !== '::1') {
        console.warn('[ApiUrlService] Refusing insecure http baseUrl in production.');
        return;
      }
      parsed.search = '';
      parsed.hash = '';
      this._baseUrl = (parsed.origin + parsed.pathname).replace(/\/$/, '');
    } catch {
      console.warn(`[ApiUrlService] Invalid URL: ${url}`);
    }
  }
}
